import { useState, useEffect } from 'react';

const IsPortrait = (): boolean => {
    
  const [portrait, setPortrait] = useState<boolean>(true);

  useEffect(() => {
    const determineOrientation = () => {
      setPortrait(window.innerWidth < window.innerHeight);
    };

    // Establecer la orientación inicial
    determineOrientation();

    window.addEventListener('resize', determineOrientation);

    // Limpiar el event listener al desmontar el componente
    return () => window.removeEventListener('resize', determineOrientation);
  }, []);

  return portrait;
};

export default IsPortrait;